export default __webpack_public_path__ + "static/media/2026_banner_2.a0e204d3.png";